import React from 'react';
import { Link } from 'react-router-dom';
import { GlassPage } from '../components/chrome';

const NotFound = () => {
  return (
    <GlassPage>
      <div className="max-w-lg mx-auto px-4 md:px-6 pt-28 md:pt-36">
        <section className="glass px-8 md:px-12 py-16 md:py-20 text-center">
          <p className="text-7xl md:text-8xl font-bold tracking-tighter text-zinc-900 mb-4">404</p>
          <h1 className="text-xl md:text-2xl font-bold tracking-tighter uppercase text-zinc-900 mb-3">Page not found</h1>
          <p className="text-sm text-zinc-600 leading-relaxed mb-10">
            This page doesn't exist or has moved. Let's get you back on track.
          </p>
          <Link to="/" className="btn-dark px-10">
            Back to home
          </Link>
        </section>
      </div>
    </GlassPage>
  );
};

export default NotFound;
